import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  showPassword: false,
  popularSearchData: {},
  editPopularSearchData: {},
  error: "",
  statusData: {},
  isLoading: false,
};

export const getPopularSearchEditData = createAsyncThunk(
  "/popular-search/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(`/popular-search/edit?search_id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const popularSearchSlice = createSlice({
  name: "popularSearch",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPopularSearchEditData.pending, (state, action) => {
        // state.isLoading = true;
      })
      .addCase(getPopularSearchEditData.fulfilled, (state, action) => {
        state.editPopularSearchData = action.payload?.data;
        // state.isLoading = false;
      })
      .addCase(getPopularSearchEditData.rejected, (state, action) => {
        // state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updateConfig } = popularSearchSlice.actions;
export default popularSearchSlice.reducer;
